import $ from 'jquery'
import {Core} from "./core.js";

export class BackToTop {
  constructor () {
    this.$body = $('body')
    this.$window = $(window)
    this.$button = $('#js-back-to-top')

    this.$button.on('click', this.handleClickBackToTop.bind(this))
  }

  handleClickBackToTop (e) {
    e.preventDefault()
    Core.scrollTo(this.$body, 500)
  }
}
